type ArrayWithoutSubset = <T>(array: T[], subset: T[]) => T[];

export const arrayWithoutSubset: ArrayWithoutSubset = (array, subset) =>
  array.filter((item) => subset.indexOf(item) < 0);
